import standard from '@/services/standard';
import Service from '@/services/Services';
import Cookies from 'js-cookie';
import type { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

let Authorization: string | null = null;

export function setAuthorization(token: string) {
  Authorization = token;
}

export default class Http extends Service {
  path: string;
  http: AxiosInstance;

  constructor(path: string, options: Record<string, unknown> = {}, http: AxiosInstance | null = null) {
    super(options);
    this.path = path;
    this.http = http || standard;
  }

  static build(path: string, options: Record<string, unknown> = {}) {
    return new this(path, options);
  }

  getHttp(): AxiosInstance {
    const _authorization = Authorization || Cookies.get('auth_greennCourse');
    this.http.defaults.headers.common['Authorization'] = _authorization;

    if (
      Cookies.get('type_student') !== undefined &&
      Cookies.get('type_student') !== '0'
    ) {
      this.http.defaults.headers.common['X-Act-Like-Student'] = '0';
    } else {
      delete this.http.defaults.headers.common['X-Act-Like-Student'];
    }

    return this.http;
  }

  async get(url: string) {
    return this.getHttp()
      .get((this.constructor as typeof Http).normalize(this.path, url))
      .then((this.constructor as typeof Http).then)
      .catch((this.constructor as typeof Http).catch);
  }

  post(url?: string, data?: unknown) {
    return this.getHttp()
      .post((this.constructor as typeof Http).normalize(this.path, url || ''), data)
      .then((this.constructor as typeof Http).then)
      .catch((this.constructor as typeof Http).catch);
  }

  put(url: string, data?: unknown) {
    return this.getHttp()
      .put((this.constructor as typeof Http).normalize(this.path, url), data)
      .then((this.constructor as typeof Http).then)
      .catch((this.constructor as typeof Http).catch);
  }

  patch(url: string, data?: unknown) {
    return this.getHttp()
      .patch((this.constructor as typeof Http).normalize(this.path, url), data)
      .then((this.constructor as typeof Http).then)
      .catch((this.constructor as typeof Http).catch);
  }

  delete(url: string) {
    return this.getHttp()
      .delete((this.constructor as typeof Http).normalize(this.path, url))
      .then((this.constructor as typeof Http).then)
      .catch((this.constructor as typeof Http).catch);
  }

  static then(response: AxiosResponse) {
    if (!response.data) {
      return {};
    }
    if (
      typeof response.data === 'string' &&
      response.headers['content-type']?.includes('application/json')
    ) {
      return JSON.parse(response.data);
    }
    return response.data;
  }

  static async catch(error: AxiosError) {
    if (!error.isAxiosError) {
      throw error;
    }
    if (error.response?.status !== 401) {
      throw error;
    }
    const body = JSON.parse(error.response.data as string);
    if (!body?.feedback) {
      throw error;
    }
  }

  static normalize(start: string, end: string): string {
    if (end.length > 0) {
      if (end[0] !== '?') return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1');
      else return `${start}${end}`.replace(/([^:]\/)\/+/g, '$1');
    } else {
      return `${start}`.replace(/([^:]\/)\/+/g, '$1');
    }
  }
}
